
import $ from 'jquery';

const accordion = (() => {
  const arrowDownBtn = () => {
    // $(".arrow-down-btn").on("click", function(){
    //   $('body,html').animate({ scrollTop: $(this).parents("section").next("section").offset().top}, 800);
    // });
  };
  const defaultAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        accordionContent.classList.toggle('js-active');
      });
    }
  };
  
  const stickyArrow = () => {
    // var scrollTopButton = document.getElementById("scrollTopBtn");

    // window.onscroll = function() {
    //     scrollFunction();
    // };

    // function scrollFunction() {
    //     if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
    //         scrollTopButton.classList.add("active");
    //     } else {
    //         scrollTopButton.classList.remove("active");
    //     }
    // }
    // scrollTopButton.addEventListener("click", scrollToTop); 
    // function scrollToTop() {
    //     scrollToTopAnimation();
    // }

    // function scrollToTopAnimation() {
    //     var currentPosition = document.documentElement.scrollTop || document.body.scrollTop;

    //     if (currentPosition > 0) {
    //         window.requestAnimationFrame(scrollToTopAnimation);
    //         window.scrollTo(0, currentPosition - currentPosition / 8);
    //     }
    // }
  }

  const reservationScroll = () => {
    var floatingDiv = document.querySelector('.position-search');
    if (floatingDiv) {
      var floatingDivParent = document.querySelector(".position-search");
      var scrollPosition = window.scrollY || document.documentElement.scrollTop;
      var scrollFirstPosition = floatingDivParent.offsetTop + floatingDiv.offsetTop - 20;
      var scrolldDataPos = floatingDivParent.setAttribute('data-offset-top', scrollFirstPosition);
      var scrollDataPosAt = floatingDivParent.getAttribute('data-offset-top');
      if (scrollPosition >= scrollDataPosAt) { 
        floatingDivParent.classList.add('fixed');
      } else { 
        floatingDivParent.classList.remove('fixed');
      }
      var minWidth = 992;

      // Check if the current window width is less than the threshold
      if (window.innerWidth >=  minWidth) {
        $(window).scroll(function() {
          var scrollPosition = window.scrollY || document.documentElement.scrollTop;
          if (scrollPosition >= scrollDataPosAt) { 
            floatingDivParent.classList.add('fixed');
          } else { 
            floatingDivParent.classList.remove('fixed');
          }
        });
      }
    } 
  };

  const filterAccordion = () => {
    // document.addEventListener("DOMContentLoaded", function() {
    //   const accordion = document.getElementById("pos-left-menu");
    //   if(accordion){
    //     document.querySelectorAll('.col-sel').forEach(item => {
    //       item.addEventListener('click', function() {
    //           const nextElement = this.nextElementSibling;
    //           if (nextElement && nextElement.classList.contains('col-list')) {
    //               nextElement.classList.toggle('active'); // Toggle 'active' class
    //           }
    //       });
    //     });
    //   }
    // });
    const isMobile = window.matchMedia("(max-width: 992px)");

    // Mobilde click olayını dinle
    if (isMobile.matches) {
        $(".col-sel").on("click", function() {
            $(this).next(".col-list").toggleClass("active");
        });
    }

  };

  const activeJobScroll = () => {
    if ($('.active-job').is(":visible")){
      var targetScroll = $('.home-current-job-eksim').offset().top;
      $(".active-job .bt-arr").on("click", function(){
        $('html, body').animate({scrollTop: targetScroll }, 'slow');
      });
    }
  }

  const init = () => {
    arrowDownBtn();
    defaultAccordion();
    stickyArrow();
    reservationScroll();
    filterAccordion();
    activeJobScroll();
  };

  return {
    init,
  };
})();

export default accordion;
